// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "pt-BR-json" + "." + "aad40529" + ".chunk.js";
};